export default __webpack_public_path__ + "static/media/tradingPsychologyItem.58c59d13.svg";